module.exports = __webpack_public_path__ + "vco-icons.1c1bfe463a8773c8b703.woff";


//////////////////
// WEBPACK FOOTER
// /builds/applied-technologies/apt-lab/digitalbank-frontend-projects/digitalbank-web/src/styles/storymap/icons/vco-icons.woff
// module id = ../../../../../src/styles/storymap/icons/vco-icons.woff
// module chunks = styles